import { ErrorPage } from '@/components/astro/pages/error';

export function Error404() {
  return <ErrorPage statusCode={404} />;
}
